import React from "react";
// import ReactPaginate from "react-paginate";
import Paginations from "react-js-pagination"; 

export default function Pagination(props) {
  // console.log(props);

  return (
    <div className="row">
      <div className="col-sm-12 col-md-5">
        <div
          className="dataTables_info"
          id="example2_info"
          role="status"
          aria-live="polite"
        >
          Showing {props.totaldata ? props.counting + 1 : 0} to{" "}
          {props.counting + 10 < props.totaldata
            ? props.counting + 10
            : props.totaldata}{" "}
          of {props.totaldata} entries
        </div>
        </div>
        {/* <div className="col-8 d-flex justify-content-end "> */}
        <div className="col-sm-12 col-md-7">
     
          <Paginations
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="⟨"
            nextPageText="⟩"
            firstPageText="«"
            lastPageText="»"
            // hideFirstLastPages={true}
            activePage={props.activePage+1} 
          totalItemsCount={props.totaldata} 
            onChange={props.onChangePage}
          />
        </div> 
    </div>
  );
}
